mainApp.component('maintenancePlanContainer', {
    templateUrl: '/public/components/configuration/maintenancePlan/maintenance-plan-container.component.html',
    bindings: {
        model: '<',
        errors: '<',
        changeListener: '&',
        accountId: '<',
        allDataLoaded: '<',
    },
    controller: maintenancePlanContainerController
});


function maintenancePlanContainerController($scope, $state, $rootScope, $filter){
    const ctrl = this;
    const RESCHEDULE_POSTPONE_DEFAULT_MSG = "All Socket upgrades that were Skipped or Pending, will be postponed until next week to install the newest version.";
    const RESCHEDULE_RETRY_MSG = "Schedule to retry upgrades for all Sockets that were Skipped or Failed to next week.";
    const CANT_POSTPONE_UPGRADE_EOL = "You can't postpone upgrades because the current versions have reached end-of-life.";
    const CANT_POSTPONE_UPGRADE_ALREADY_POSTPONED_IN_LAST_WEEK = "You can't postpone upgrades because the plan was Postponed in the last week.";
    const CONTINUE_QUESTION = " Do you want to continue?";

    ctrl.$onInit = function() {
        ctrl.original = angular.copy(ctrl.model);
        ctrl.titleStyle = "";
        ctrl.successProgress = 0;
        ctrl.skipProgress = 0;
        ctrl.message = "";
        ctrl.socketsStatus;
        getMaintenancePlanStatus();
    }

    ctrl.$doCheck = function() {
        if (ctrl.model){
            if (!ctrl.changeListener)
                return;

            // There are many front-end changes made in the socketsStatus - this is a field we dont save in the back-end in any case,
            // We do not want the SAVE BUTTON to be triggered
            ctrl.original.socketsStatus = ctrl.model.socketsStatus;
            // The approach here is NAIVE, but we know no phases are removed from the array or move in the array by the front-end.
            if (ctrl.original.maintenancePhases.length === ctrl.model?.maintenancePhases.length){
                for (let i = 0; i < ctrl.original.maintenancePhases.length; i++){
                    ctrl.original.maintenancePhases[i].socketsStatus = ctrl.model.maintenancePhases[i].socketsStatus;
                }
            }
            ctrl.original.planStatus =  ctrl.model.planStatus;

            var isChangedNow = !angular.equals(ctrl.model, ctrl.original);

            // we only care when state is changed...
            if (ctrl.hasChanges === isChangedNow)
                return;

            ctrl.hasChanges = isChangedNow;
            ctrl.changeListener({isDirty: ctrl.hasChanges, componentName: 'maintenancePlan'});
            updatePlanTitleParams();
        }
    }

    $scope.$on('modelReloadedEvent', function (event, data) {
        ctrl.original = angular.copy(ctrl.model);
        setPlanStatus();
        setTitleStyle();
    });

    let setProgressBarParams = function () {

        if (ctrl.model && ctrl.model.socketsStatus){
            ctrl.successProgress = (ctrl.model.socketsStatus.success / ctrl.model.socketsStatus.total) * 100;
            ctrl.skipProgress = (ctrl.model.socketsStatus.skip / ctrl.model.socketsStatus.total) * 100;
        }
    }

    let setPlanStatus = function () {

        if (ctrl.model.socketsStatus.fail > 0){
            ctrl.model.planStatus = "FAIL";
        }else if (ctrl.socketsStatus && ctrl.socketsStatus !== 'EMPTY'){
            ctrl.model.planStatus = "IN_PROGRESS"
        }else{
            ctrl.model.planStatus = "SUCCESS"
        }

        ctrl.planStatus = ctrl.model.planStatus;
        ctrl.message = "";
        let versionMessage = setVersionMessage();
        if (ctrl.model.planStatus === 'IN_PROGRESS'){
            ctrl.message = "Upgrading to " + versionMessage + ". Next upgrade phase starts on " + new moment(ctrl.model.nextPhaseTime).format('L');
        }else if (ctrl.model.planStatus === 'FAIL'){
            ctrl.message = "Upgrade process to " + versionMessage + " failed on " + ctrl.model.socketsStatus.fail + " sockets. (" + ctrl.model.socketsStatus.skip +" sockets skipped upgrade, " + ctrl.model.socketsStatus.success + " sockets upgraded successfully)";
            ctrl.planStatus = "Failed"
        }else {
            ctrl.message = "Successfully upgraded to " + versionMessage;
            if (ctrl.model.socketsStatus.skip){
                ctrl.message += ". (Upgrade skipped for " + ctrl.model.socketsStatus.skip +" Sockets)"
            }else {
                ctrl.message += ". All Sockets are up-to-date.";
            }
        }
    }

    let setVersionMessage = function () {

        let versionsArr =  Object.values(ctrl.model.socketPlatformToVersionMap).filter((value, index, self) => self.indexOf(value) === index);

        if (versionsArr.length > 1){
            let versionString = "";
            Object.keys(ctrl.model.socketPlatformToVersionMap).forEach(key =>{
                versionString += ctrl.model.socketPlatformToVersionMap[key] + " for " + $filter('getSiteConnTypeString')(key) + ", ";
            })
            //remove the last comma
            return versionString.slice(0, -2);
        }else {
            return "version " + versionsArr.pop();
        }
    }

    let setEolPostponeMsg= function(){
        let eolPlatformsToVersionStr = JSON.stringify(ctrl.model.eolPlatformsCurrVersion)
            .replace(/["\{\}\[\]"]/g, "")
            .replace(/[:]/g, " version ")
            .replace(/["_BR2"]/g, "")
            .replace(/("\w+ version \d*.\d*.\d*")/g, "$',")


        let message = "You can't postpone upgrades for the following Sockets because the versions are end-of-life: ";
        message += eolPlatformsToVersionStr;
        message += ". Instead they will be upgraded as planned."
        message += " All Other Socket upgrades that were Skipped or Pending, will be postponed until next week to install the newest version.";

        return message;
    }

    let setTitleStyle = function () {
        if (ctrl.model.planStatus === 'FAIL'){
            ctrl.titleStyle = "failure";
        }else if (ctrl.model.planStatus === 'SUCCESS'){
            ctrl.titleStyle = "success";
        }else{
            ctrl.titleStyle = "";
        }
    }

    ctrl.openPopup = function () {
        if (ctrl.model.planStatus === 'IN_PROGRESS'){
            if (!ctrl.model.areAllTargetUpgradesEol){
                if (ctrl.model.canPostpone){
                    ctrl.rescheduleMessage = Object.keys(ctrl.model.eolPlatformsCurrVersion).length === 0 ? RESCHEDULE_POSTPONE_DEFAULT_MSG : ctrl.RESCHEDULE_POSTPONE_EOL_MSG;
                    ctrl.rescheduleMessage += CONTINUE_QUESTION;
                }else{
                    ctrl.rescheduleMessage = CANT_POSTPONE_UPGRADE_ALREADY_POSTPONED_IN_LAST_WEEK;
                }
            }else{
                ctrl.rescheduleMessage = CANT_POSTPONE_UPGRADE_EOL;
            }
        }else if (ctrl.model.planStatus === 'FAIL') {
            ctrl.rescheduleMessage = RESCHEDULE_RETRY_MSG + CONTINUE_QUESTION;
        }
        $rootScope.openPopup('rescheduleDlg');
    }

    ctrl.closePopupNoAction = function () {
        $rootScope.closePopup('rescheduleDlg');
    }

    ctrl.closeAndPostponeRetryPopup = function () {
        $rootScope.closePopup('rescheduleDlg');
        if (ctrl.model.planStatus === 'IN_PROGRESS'){
            rescheduleMaintenancePlan();
        }else{
            retryMaintenancePlan();
        }

    }

    // if the plan is IN PROGRESS but no upgrades have started yet,
    let rescheduleMaintenancePlan = function(){

        let shouldPostponeByOneWeek = true;

        if (ctrl.model.beginFirstPhase){
            let firstPhase = new moment(ctrl.model.beginFirstPhase);
            let now = new moment();

            shouldPostponeByOneWeek = (now.diff(firstPhase) < - 1000 * 60 * 60 * 48)
        }

        let params = {'accountId': ctrl.accountId, 'shouldPostpone': shouldPostponeByOneWeek};

        store.save({
            path: "/rescheduleMaintenancePlan",
            data: params,
            dataObj: 'json',
            queryParams: params,
            success: function(data) {
                $scope.$root.handleServerResponse(data, "" , 'Upgrade rescheduled');
            }
        });
    }

    // send to server request to upgrade socket
    let retryMaintenancePlan = function(){

        let params = {'accountId': ctrl.accountId, 'shouldPostpone': false};

        store.save({
            path: "/retryMaintenancePlan",
            data: params,
            dataObj: 'json',
            queryParams: params,
            success: function(data) {
                $scope.$root.handleServerResponse(data, "" , 'Upgrade rescheduled');
            }
        });
    }

    let getMaintenancePlanStatus = function(){

        let params = {'accountId': ctrl.accountId};

        store.fetch({
            method: 'GET',
            path: "/getMaintenancePlanStatus",
            queryParams: params,
            success: function(data) {
                ctrl.socketsStatus = data ? data : "EMPTY";
                ctrl.allDataLoaded = true;

                updatePlanTitleParams();
            }
        });
    }

    let updatePlanTitleParams = function(){
        if (ctrl.socketsStatus != null && ctrl.socketsStatus != 'EMPTY'){
            setModelSocketStatuses();
        }

        if (ctrl.model){
            setProgressBarParams();
            setPlanStatus();
            setTitleStyle();
            ctrl.RESCHEDULE_POSTPONE_EOL_MSG = setEolPostponeMsg();
        }
    }

    let setModelSocketStatuses = function () {

        let planSocketStatus = Object.keys(ctrl.socketsStatus).reduce(function (r, k) {
            return r.concat(ctrl.socketsStatus[k]);
        }, []);

        ctrl.model.socketsStatus.fail = planSocketStatus.filter(socket => socket.status === 'FAIL').length;
        ctrl.model.socketsStatus.skip = planSocketStatus.filter(socket => socket.status === 'SKIP').length;
        ctrl.model.socketsStatus.success = planSocketStatus.filter(socket => socket.status === 'SUCCESS').length;
        ctrl.model.socketsStatus.pending = planSocketStatus.length - (ctrl.model.socketsStatus.fail + ctrl.model.socketsStatus.skip + ctrl.model.socketsStatus.success);

        ctrl.model.maintenancePhases.forEach(phase =>{

            let phaseSocketsStatus = ctrl.socketsStatus[phase.id];

            if (phaseSocketsStatus){
                phase.socketsStatus.fail = phaseSocketsStatus.filter(socket => 'FAIL' === socket.status).length;
                phase.socketsStatus.skip = phaseSocketsStatus.filter(socket => 'SKIP' === socket.status).length;
                phase.socketsStatus.success = phaseSocketsStatus.filter(socket => 'SUCCESS' === socket.status).length;
                phase.socketsStatus.pending = phaseSocketsStatus.length - (phase.socketsStatus.fail + phase.socketsStatus.skip + phase.socketsStatus.success);
            }
        });
    }
};




